import { DivWithWhiteBackgroundAndBlackBordersThin } from "../../styles/styles";

export const AboutPage: React.FC = () => {
  return (
    <DivWithWhiteBackgroundAndBlackBordersThin>
      Few artists can claim that their debut single is about cake. Jacob
      Blackfly can, though that doesn’t mean desserts are the only thing he
      talks about in his self-produced indie-pop songs. Born and bred in
      Brussels with Finnish roots and currently based in Helsinki, Jacob
      Blackfly grew up surrounded by a mix of vintage and contemporary pop,
      classical music and classic rock and blues, before later discovering
      electronic music and RnB (Adele, Corinne Bailey Rae, AC/DC, The Beatles,
      Rufus Du Sol, Moonchild). Echoes from these genres can be heard in Jacob’s
      music, which includes piano ballads with an electronic touch, pop-rock and
      even 90s-style hip hop, keeping a consistent focus on catchy melodies and
      memorable grooves. June 2025 saw the release of Jacob’s 4-track debut EP
      “Searching”, which includes the singles “Avoidant”, “Searching” and “180
      Degrees”, as well as music videos for the latter 2. The EP has garnered
      2000+ streams across platforms. Jacob is also co-writing and producing a
      single “Leikitään” with Kultapoiki. Jacob has performed his own music at
      venues across Helsinki, including Käpygrilli, Linna Bar, Playhouse Bar and
      Tiivistämö. He has also performed as a band member in other musicians'
      projects. Kallio Block Party and Herttoniemi Block Party founder, member
      of Kontula Electronic working group Mikko Heinänen comments on Jacob’s
      music (Feb 2025): “Jacob has a clearly distinctive voice in his songs.”
    </DivWithWhiteBackgroundAndBlackBordersThin>
  );
};
